import WalletPubHeader from "./components/pub-header";
import WalletPubList from "./components/pub-list";
import { WalletPubTitle, WalletPubWrapper } from "./style";

const WalletPub = () => {
  return (
    <WalletPubWrapper>
      <WalletPubHeader />
      <WalletPubTitle>매장 이용권</WalletPubTitle>
      <WalletPubList />
    </WalletPubWrapper>
  );
};

export default WalletPub;
